// extracted by mini-css-extract-plugin
module.exports = {"root":"ScreenToolbarActionGroup_root__1BoUz"};